import { Editor, Node, Path, Range, Transforms } from "slate";
import {
  ELEMENT_CUSTOM_BUTTON,
  ELEMENT_DIVIDER,
  ELEMENT_GOVLAUNCH_PROJECT,
  ELEMENT_SIMPLECAST,
  ELEMENT_SOCIAL_MEDIAS,
  ELEMENT_SUBSCRIBE_BUTTON,
  getNewParagraph,
} from "./Element";

const withCorrectVoidBehavior = (editor) => {
  const { deleteBackward, insertBreak, deleteForward } = editor;

  // if current selection is void node, insert a default node below
  editor.insertBreak = () => {
    if (!editor.selection || !Range.isCollapsed(editor.selection)) {
      return insertBreak();
    }

    const selectedNodePath = Path.parent(editor.selection.anchor.path);
    const selectedNode = Node.get(editor, selectedNodePath);

    if (
      !Editor.isVoid(editor, selectedNode) &&
      Path.hasPrevious(selectedNodePath) &&
      (selectedNode.type === ELEMENT_SOCIAL_MEDIAS ||
        selectedNode.type === ELEMENT_DIVIDER ||
        selectedNode.type === ELEMENT_SIMPLECAST ||
        selectedNode.type === ELEMENT_GOVLAUNCH_PROJECT ||
        selectedNode.type === ELEMENT_CUSTOM_BUTTON ||
        selectedNode.type === ELEMENT_SUBSCRIBE_BUTTON)
    ) {
      const previousNodePath = Path.previous(selectedNodePath);
      Transforms.select(editor, previousNodePath);
      Editor.insertNode(editor, getNewParagraph());
      return;
    }

    if (Editor.isVoid(editor, selectedNode)) {
      Editor.insertNode(editor, getNewParagraph());
      return;
    }

    insertBreak();
  };

  // if prev node is a void node, remove the current node and select the void node
  editor.deleteBackward = (unit) => {
    if (!editor.selection || !Range.isCollapsed(editor.selection) || editor.selection.anchor.offset !== 0) {
      return deleteBackward(unit);
    }

    const parentPath = Path.parent(editor.selection.anchor.path);
    const parentNode = Node.get(editor, parentPath);
    const parentIsEmpty = Node.string(parentNode).length === 0;

    if (parentIsEmpty && Path.hasPrevious(parentPath)) {
      const prevNodePath = Path.previous(parentPath);
      const prevNode = Node.get(editor, prevNodePath);
      if (Editor.isVoid(editor, prevNode)) {
        return Transforms.removeNodes(editor);
      }
    }

    // never ever delete the first node
    if (editor.selection.anchor.path[0] === 0 && editor.children.length === 1) {
      Transforms.removeNodes(editor);
      return Transforms.insertNodes(editor, getNewParagraph());
    }
    if (editor.selection.anchor.path[0] === 0 && editor.children.length > 1) {
      return Transforms.removeNodes(editor);
    }

    deleteBackward(unit);
  };

  editor.deleteForward = (unit) => {
    // never ever delete the first node
    if (editor.selection.anchor.path[0] === 0 && editor.children.length === 1) {
      Transforms.removeNodes(editor);
      Transforms.insertNodes(editor, getNewParagraph());
    } else {
      deleteForward(unit);
    }
  };

  return editor;
};

export default withCorrectVoidBehavior;
